import Big from "big.js"
export * from "./FloatMath"

// import { FloatMath } from "./FloatMath"

export const CalculationUtils: TCalculation = {
  add(a, b) {
    try {
      return new Big(a).plus(b).toNumber()
      // return Number(TinyAPI.number.add(String(a), String(b)))
      // return a + b
      // return FloatMath.add(a, b)
    } catch (e) {
      throw new Error("[math.add] error: " + (e?.message || JSON.stringify(e)))
    }
  },
  subtract(a, b) {
    try {
      return new Big(a).minus(b).toNumber()
      // return Number(TinyAPI.number.subtract(String(a), String(b)))
      // return a - b
      // return FloatMath.subtract(a, b)
    } catch (e) {
      throw new Error(
        "[math.subtract] error: " + (e?.message || JSON.stringify(e))
      )
    }
  },

  multiply(n, multiplier) {
    try {
      return new Big(n).times(multiplier).toNumber()
      // return Number(TinyAPI.number.multiply(String(n), String(multiplier)))
      // return n * multiplier
      // return FloatMath.multiply(n, multiplier)
    } catch (e) {
      throw new Error(
        "[math.multiply] error: " + (e?.message || JSON.stringify(e))
      )
    }
  },
  divide(n, divisor) {
    try {
      return new Big(n).div(divisor).toNumber()
      // return Number(TinyAPI.number.divide(String(n), String(divisor)))
      // return n / divisor
      // return FloatMath.divide(n, divisor)
    } catch (e) {
      throw new Error(
        "[math.divide] error: " + (e?.message || JSON.stringify(e))
      )
    }
  },
  toFixed(n, digits) {
    try {
      return +new Big(n).toFixed(digits)
    } catch (e) {
      throw new Error(
        "[math.toFixed] error: " + (e?.message || JSON.stringify(e))
      )
    }
  },
}
